import { request } from '@umijs/max';

// 获取用户申请分页列表
export async function getUserApplyPage(params: API.PageParams) {
  return request('/api/shop/workflowUser/page', {
    method: 'POST',
    data: {
      ...params,
      with: [
        'shop',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'rentFiles',
        'sfzFiles',
        'hukouFiles',
        'dibaoFiles',
        'nengliFiles',
      ],
    },
  });
}

// 获取用户申请详情
export async function getUserApplyInfo(params: { id: number }) {
  return request('/api/shop/workflowUser/info', {
    method: 'POST',
    data: {
      ...params,
      with: [
        'shop',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'rentFiles',
        'sfzFiles',
        'hukouFiles',
        'dibaoFiles',
        'nengliFiles',
      ],
    },
  });
}

// 新增用户申请
export async function addUserApply(params: API.UserApplyFormType) {
  return request('/api/shop/workflowUser/add', {
    method: 'POST',
    data: params,
  });
}

// 获取COS文件真实访问链接
export async function getViewUrl(params: { url: string[] }) {
  return request('/api/shop/cos/viewUrl', {
    method: 'POST',
    data: params,
  });
}
